import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Customer',
    show: true,
    width: 417,
    valuesExport: [
      'companyName',
      'status',
      'companySize',
      'customerType',
      'country',
      'website'
    ]
  },
  {
    isSortable: true,
    field: 'networkName',
    title: 'Network Name',
    show: true,
    width: 164,
    valuesExport: ['networkName']
  },
  {
    isSortable: true,
    field: 'networkId',
    title: 'Network ID',
    show: true,
    width: 164,
    valuesExport: ['networkId']
  },
  {
    isSortable: false,
    field: 'gatewayImageType',
    title: 'Gateway Image Type',
    show: true,
    width: 216,
    valuesExport: ['gatewayImageType']
  },
  {
    isSortable: false,
    field: 'gatewayImageVersion',
    title: 'Gateway Image Version',
    show: true,
    width: 282,
    valuesExport: ['gatewayImageVersion']
  },
  {
    isSortable: true,
    field: 'networkDns',
    title: 'Network DNS',
    show: true,
    width: 282,
    valuesExport: ['networkDns']
  },
  {
    isSortable: true,
    field: 'networkVersion',
    title: 'Version',
    show: true,
    width: 282,
    valuesExport: ['networkVersion']
  },
  {
    isSortable: true,
    field: 'provider',
    title: 'Cloud Provider',
    show: true,
    width: 202,
    valuesExport: ['provider']
  },
  {
    isSortable: true,
    field: 'regionName',
    title: 'Region',
    show: true,
    width: 202,
    valuesExport: ['regionName']
  },
  {
    isSortable: true,
    field: 'gatewayId',
    title: 'Gateway ID',
    show: true,
    width: 142,
    valuesExport: ['gatewayId']
  },
  {
    isSortable: true,
    field: 'gatewayIp',
    title: 'Gateway IP',
    show: true,
    width: 142,
    valuesExport: ['gatewayIp']
  },
  {
    isSortable: false,
    field: 'gatewayStatus',
    title: 'Gateway Status',
    show: true,
    width: 142,
    valuesExport: ['gatewayStatus']
  },

  {
    isSortable: true,
    field: 'regionCountry',
    title: 'Net Region Country',
    show: true,
    width: 192,
    valuesExport: ['regionCountry']
  },
  {
    isSortable: true,
    field: 'providerRegionName',
    title: 'Net Provider Region',
    show: true,
    width: 202,
    valuesExport: ['providerRegionName']
  },
  {
    isSortable: false,
    field: 'plan',
    title: 'Pricing Plan',
    show: true,
    width: 126,
    valuesExport: ['plan']
  },
  {
    isSortable: false,
    field: 'billingCycle',
    title: 'Billing Cycle',
    show: true,
    width: 142,
    valuesExport: ['billingCycle']
  },
  {
    isSortable: false,
    field: 'accountManager',
    title: 'Acc. Manager',
    show: true,
    width: 154,
    valuesExport: ['accountManager']
  },
  {
    isSortable: false,
    field: 'customerSuccessEngineer',
    title: 'CS Engineer',
    show: true,
    width: 154,
    valuesExport: ['customerSuccessEngineer']
  },
  {
    isSortable: false,
    field: 'regionStatus',
    title: 'Region Status',
    show: true,
    width: 154,
    valuesExport: ['regionStatus']
  },
  {
    isSortable: false,
    field: 'regionPublicIp',
    title: 'Region Public IP',
    show: true,
    width: 154,
    valuesExport: ['regionPublicIp']
  }
];

export const deviceTableConf = [
  {
    field: 'tunnelId',
    title: 'Tunnel ID'
  },
  {
    field: 'tunnelName',
    title: 'Tunnel Name'
  },
  {
    field: 'tunnelType',
    title: 'Tunnel Type'
  },
  {
    field: 'tunnelStatus',
    title: 'Tunnel Status'
  },
  {
    field: 'tunnelIp',
    title: 'Tunnel Endpoint'
  },
  {
    field: 'leftSubnets',
    title: 'Left subnets'
  },
  {
    field: 'customerSubnets',
    title: 'Customer Subnets'
  }
];

export const defaultFilters = {
  search: '',
  'tunnels.tunnelType': [],
  companySize: [],
  country: [],
  regionName: [],
  regionCountry: [],
  plan: [],
  billingCycle: [],
  accountManager: [],
  customerSuccessEngineer: [],
  status: ['Active', 'Non Renewing'],
  networkVersion: [],
  providerRegionName: [],
  provider: [],
  gatewayImageType: [],
  gatewayImageVersion: []
};

export const defaultNavigation = {
  fieldName: 'companyName',
  direction: initialTableShow.direction * -1,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const exportConfigNetworks = {
  exportUrl: '/rd/networks/export',
  exportName: 'Networks',
  exportFormat: 'zip'
};
